var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIoNet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3999 9.60101L4.41977 10.9695H2.3999V16.0618H4.41977V10.9695V7.91422H2.3999V9.60101Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0739 9.9477C16.3586 9.9477 16.58 10.1701 16.58 10.4561V11.6317L18.6044 12.9979V9.9477C18.6044 8.83564 17.6871 7.91422 16.58 7.91422H4.46533L7.50191 9.9477H16.1055H16.0739Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99142 14.0283C9.70673 14.0283 9.48532 13.8059 9.48532 13.5199V12.3443L7.46094 10.9781V14.0283C7.46094 15.1403 8.37823 16.0618 9.48532 16.0618H21.6L18.5634 14.0283H9.95978H9.99142Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIoNet);
export default __webpack_public_path__ + "static/media/io-net.5287fc47212de32e343c9fc4e761e0d9.svg";
export { ForwardRef as ReactComponent };